import styled from 'styled-components';
import { palette } from '@m12s/component-library';

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const OptionRow = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 1.5rem;
  height: 4rem;
  border-radius: 0.25rem;
  gap: 0.5rem;
  justify-content: space-between;

  background: ${({ selected, disabled }) => {
    return selected ? palette.Indigo600 : disabled ? palette.Grey100 : '#fff';
  }};

  color: ${({ selected, disabled }) => {
    return selected ? '#fff' : disabled ? palette.Grey400 : palette.Grey800;
  }};

  border: ${({ selected }) => {
    const color = selected ? palette.Indigo600 : palette.Grey400;
    return `0.063rem solid ${color}`;
  }};

  cursor: ${({ disabled }) => {
    return disabled ? 'not-allowed' : 'pointer';
  }};

  transition: background 0.15s, color 0.15s;
  outline: none;
`;

export const OptionLabel = styled.span`
  /* Base text styling */
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem; /* 120% */
  letter-spacing: 0.1px;
  text-align: center;

  /* Dynamic color based on parent state */
  color: ${({ selected, disabled }) => {
    if (selected) return palette.White;
    if (disabled) return palette.Grey500;
    return palette.Grey700;
  }};
`;

export const OptionTime = styled.span`
  /* Base text styling */
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem; /* 120% */
  letter-spacing: 0.1px;
  text-align: center;

  /* Dynamic color based on parent state */
  color: ${({ selected, disabled }) => {
    if (selected) return palette.White;
    if (disabled) return palette.Grey500;
    return palette.Grey700;
  }};
`;
